export const resetWidgetsObj = () => {
  return {
    type: 'RESET_WIDGETS_OBJ',
    payload: {},
  }
}
export const resetWidgetsStatus = (reset) => {
  return {
    type: 'RESET_WIDGETS_STATUS',
    payload: reset,
  }
}

export const widgetsError = (error) => {
  return {
    type: 'WIDGETS_ERROR',
    payload: error,
  }
}

export const getWidgets = (data) => {
  return {
    type: 'GET_WIDGETS',
    payload: data,
  }
}
export const setWidgets = (data) => {
  return {
    type: 'SET_WIDGETS',
    payload: data,
  }
}

export const getWidget = (data) => {
  return {
    type: 'GET_WIDGET',
    payload: data,
  }
}
export const setWidget = (data) => {
  return {
    type: 'SET_WIDGET',
    payload: data,
  }
}
export const deleteWidget = (chatId) => {
  return {
    type: 'DELETE_WIDGET',
    payload: chatId,
  }
}
